import { CheckIcon } from "../../../assets/CheckIcon";

export default function DoneCard({
  isTestDriveFlow,
  vehicleLabel,
  selectedDate,
  selectedTime,
  formatDate,
  formatSlot2h,
  showEstimateTradeInButton,
  onEstimateTradeIn,
}: {
  isTestDriveFlow: boolean;
  vehicleLabel: string;
  selectedDate: Date | null;
  selectedTime: string | null;
  formatDate: (d: Date) => string;
  formatSlot2h: (t: string) => string;
  showEstimateTradeInButton?: boolean;
  onEstimateTradeIn?: () => void;
}) {
  return (
    <div className="tdb-doneCard">
      <div className="tdb-doneInner">
        <div className="tdb-doneIconWrap">
          <CheckIcon className="tdb-doneIcon" />
        </div>

        <div>
          <p className="tdb-doneTitle">Demande envoyée ! 🎉</p>

          {isTestDriveFlow ? (
            <>
              <p className="tdb-doneSub">
                Essai de la{" "}
                <span className="tdb-accentText">{vehicleLabel}</span>
              </p>

              {selectedDate && selectedTime && (
                <p className="tdb-doneSub">
                  {formatDate(selectedDate)} — {formatSlot2h(selectedTime)}
                </p>
              )}
            </>
          ) : null}

          <p className="tdb-doneHint">
            Nous revenons vers vous très rapidement par téléphone.
          </p>

          {showEstimateTradeInButton && onEstimateTradeIn && (
            <button
              type="button"
              className="tdb-primaryBtn"
              style={{ marginTop: 14 }}
              onClick={onEstimateTradeIn}
            >
              Estimer ma reprise
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
